// File: src/components/ScrollToTop.tsx

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ children }: { children: React.ReactNode }) => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // You can use 'auto' for instant scrolling
        });
    }, [pathname]);

    return <>{children}</>;
};

export default ScrollToTop;
